import { WriteRequest } from "~/backendApis/foundation/WriteRequest"

export class ResignUserAccountWriteRequest extends WriteRequest<void> {
  private readonly endpoint = "/user_account/user/user_account/resign"

  public post(): Promise<void> {
    return this.apiClient.post(this.endpoint, {})
  }
}
